import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {environment} from "@env/environment";
import {catchError, retry} from "rxjs/operators";
import {Observable, of} from "rxjs";
import {ConstantsService} from "@app/services/constants/constants.service";

@Injectable({
    providedIn: 'root'
})
export class CommentsService {
    apiURL = environment.apiURL;
    taskId: string = '';

    constructor(private http: HttpClient,
                private constantsService: ConstantsService) {
    }

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            return of(result as T);
        };
    }

    addComment(taskId, textComment, sort, attachments) {
        this.taskId = taskId;
        let params = new HttpParams()
            .set('creator', this.constantsService.getLoggedInUserId().toString())
            .set('task_id', taskId)
            .set('comment', textComment)
            .set('sort', sort)
            .set('attachments', JSON.stringify(attachments));
        return this.http.post<Response>(this.apiURL + '/task/addComment', params).pipe(
            retry(1),
            catchError(this.handleError<any>('addComment')));
    }

    getComments(id) {
        this.taskId = id;
        let params = new HttpParams().set('task_id', this.taskId);
        return this.http.get(this.apiURL + '/task/getComments', {params: params}).pipe(
            retry(1),
            catchError(this.handleError<any>('getComments')));
    }

}
